export default __webpack_public_path__ + "static/media/login-pot.feb48e8f.png";